module.exports = __webpack_public_path__ + "64f61e708d2202c85a5bfdcd3efab57f.pdf";